



























import VueOptions from '@utils/VueOptions'
import SponsorSetList from '@ui/SponsorSet/SponsorSetList'

settings =
  name: 'EventBrandPartners'

  vue:
    props: ['event', 'options']
    components: { SponsorSetList }

    computed:
      campaign: -> @options?.campaign

export default VueOptions.vue settings
